<!--契約照会 詳細-->
<template>
  <div style="margin-top:10px">
    <div v-for="item in list" :key="item.key">
      <el-row :gutter="0" style="background-color:#3cc6fa;text-align:center">
        <div class="table-header">{{item.title}}</div>
      </el-row>
      <el-table :data="item.itemContent" class="table-label" :show-header=false :row-class-name="c0002IsRowClass" :cell-style="c0002IsCellStyle" :cell-class-name="c0002IsCellClass">
        <el-table-column width="127px">
          <template slot-scope="scope">
            <div>{{scope.row.itemName}}</div>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <div style="white-space: pre-wrap">{{scope.row.contractText}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 誓約チェック -->
    <el-checkbox v-show="pageShow" v-model="pledgeCheck" @change="pledgeCheckChange(pledgeCheck)" style="margin-left:5px;margin-top:10px"><span>
        <div slot="content" v-html="$t('MODULE.C0002_LBL_CHECKBOX1')"></div>
      </span></el-checkbox>
    <!-- 同意チェック -->
    <el-checkbox v-show="pageShow" v-model="consentCheck" :disabled="!pledgeCheck" style="margin-left:5px;margin-top:10px">{{$t('MODULE.C0002_LBL_CHECKBOX2')}}</el-checkbox>
    <div v-show="!pageShow" style="padding-top: 5px;padding-bottom: 5px;padding-left: 5px;font-size: 12pt;">{{consentText}}</div>
    <div align="center">
      <!-- 同意ボタン -->
      <el-button v-show="pageShow" class="css-btn css-button" style="margin-top: 8px;font-size: 13px;width:20%;" type="primary" :disabled="!consentCheck" @click="basicInfoApply">{{$t('MODULE.C0002_BTN_APPLY')}}</el-button>
      <!-- 戻るボタン -->
      <el-button class="css-btn css-button" style="margin-top: 8px;font-size: 13px;width:20%" type="primary" @click="back_click">{{$t('MODULE.C0002_BTN_RETURN')}}</el-button>
      <!-- 印刷ボタン -->
      <el-button class="css-btn css-button" v-show="printBtnShow" style="margin-top: 8px;font-size: 13px;width:20%" type="primary" @click="print_click">{{$t('MODULE.C0002_BTN_PRINT')}}</el-button>
    </div>
    <el-dialog fullscreen :visible.sync="viewVisible" :close-on-click-modal="false" :show-close="false" width="100%" top="52px" height="120%">
      <Pdf :src="pdfUrl" @pdfClose="pdfClose"></Pdf>
    </el-dialog>
  </div>
</template>
<script>
import * as amsApi from "../api/c_0002"
import * as menuApi from "@/components/api/home"
import locale from "element-ui/lib/locale/lang/ja"
import Vue from "vue"
import ElementUI from "element-ui"
import css from "@/statics/css"
import pdf from '@/components/page/pdf'
let url = require('@/../config/sysConfig')
Vue.use(ElementUI, { locale })
export default {
  mixins: [css],
  components: {
    Pdf: pdf
  },
  data() {
    return {
      obj: [],
      listLoading: false,
      pledgeCheck: false,//誓約チェック
      consentCheck: false,//同意チェック
      pageShow: true,
      list: [],
      issueDate: "",//発行日
      consentDate: "",//同意日時
      consentText: "",//同意項目表示
      recNo: "", //レコード番号 
      dataSource: "",//データ元
      userInfo: [],//用户信息
      printBtnShow: false,//印刷ボタンの表示
      contractPath: "",//契約書パス
      //pdfFlag
      viewVisible: false,
      pdfUrl: '',
    }
  },
  created() {
    this.obj = JSON.parse(localStorage.getItem('obj'));
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.recNo = this.obj.recNo;
    this.issueDate = this.obj.issueDate;
    this.consentDate = this.obj.consentDate;
    this.dataSource = this.obj.dataSource;
    this.contractPath = this.obj.contractPath; //契約書パス
    //默认值
    if (!(this.dataSource && this.dataSource.trim() !== '')) {
      this.dataSource = '1';
    }
    //【同意日時：YYYYMMDD HH:MM:SS】で表示する。
    if (this.consentDate != '' && this.consentDate != null) {
      this.consentText = this.$t('MODULE.C0001_LBL_COLUMN3') + "：" + this.consentDate;
      this.pageShow = false;
    }
    //IF.契約書パスがNull以外の場合のみ、ボタン表示 以外の場合、非表示
    if (this.contractPath != '' && this.contractPath != null) {
      this.printBtnShow = true;
    }
    this.init_query();
  },
  methods: {
    // 初期化
    init_query() {
      // 検索
      this.query(this.recNo, this.dataSource);
      //1：確認
      this.saveProcess(this.recNo, "1", this.dataSource);
    },
    // 検索
    query(recNo,dataSource) {
      var params = {
        "recNo": recNo
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
      //検索処理
      amsApi.c_0002(params,this.dataSource).then(res => {
        //API数据
        //this.list = res.items.contractDetailSet;
        this.list = this.formartListData(res.items.contractDetailSet);
        if (res.code === 300) {
          this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
          loading.close()
          return
        }
        loading.close();
      }).catch((err) => {
        //关闭loading
        loading.close();
      });
    },
    //整理API返回的数据
    formartListData(list) {
      //返回结构体
      // contractDetailSetList = [
      //                           { //contractDetailSet
      //                             key : "",
      //                             title : "",
      //                             itemContent : [
      //                                             {
      //                                               itemName : "",
      //                                               contractText : "",
      //                                             },
      //                                           ],
      //                           }
      //                         ]

      var contractDetailSetList = [];
      var contractDetailSetIndex = 0;
      for (let i = 0; i < list.length; i++) {
        var items = list[i];
        var itemContent = {
          itemName: "",
          contractText: "",
        }
        if (items.title != "") {
          var contractDetailSet = {
            key: "",
            title: "",
            itemContent: [],
          }
          contractDetailSet.key = contractDetailSetIndex;
          contractDetailSet.title = items.title;

          itemContent.itemName = items.itemName;
          itemContent.contractText = items.contractText;
          contractDetailSet.itemContent.push(itemContent);
          contractDetailSetList.push(contractDetailSet);
          contractDetailSetIndex++;
        } else {
          itemContent.itemName = items.itemName;
          itemContent.contractText = items.contractText;

          contractDetailSetList[contractDetailSetIndex - 1].itemContent.push(itemContent);
        }
      }
      //APIから「タイトル」が有る場合、タイトル様式を設定する
      //「契約文言」だけタイトル様式として表示する
      for (let i = 0; i < contractDetailSetList.length; i++) {
        var items = contractDetailSetList[i];
        if (items.title == "TITLE") {
          if (items.itemContent.length > 0) {
            items.title = items.itemContent[0].contractText;
            items.itemContent.splice(0, 1); //删除明细行和title重复的数据
          }
        }
      }
      return contractDetailSetList;
    },
    //保存
    saveProcess(recNo, division, dataSource) {
      var params = [];
      var param = {
        "recNo": recNo,
        "division": division //1：確認 , 2：同意
      }
      params.push(param);
      //保存
      amsApi.c_0002_save(params,this.dataSource).then(res => {
        if (res.code == "202") {
          if (division == "2") {
            //保存しました。
            this.$message.success({ message: this.$t('COMMON.MSG_INSERTED'), showClose: true });
            this.$store.commit('increment', '0')
            this.handleMenuState()
            this.back_click();
          }
        } else {
          //処理失敗しました。
          this.$message.error({ message: this.$t('COMMON.' + res.message), showClose: true });
        }
      });
    },
    //获取menu状态
    handleMenuState() {
      menuApi.menuStateManager(this.userInfo.userCd).then(res => {
        if (res.code == 204) {
          let menuState = res.items.menuState[0]
          localStorage.setItem("menuState", JSON.stringify(menuState))
        }
      })
    },
    // 申請
    basicInfoApply() {
      //2：同意
      this.saveProcess(this.recNo, "2", this.dataSource);
    },
    // 戻る処理
    back_click() {
      var returnC0001Param = JSON.parse(localStorage.getItem('C0001search_condition'));
      var vm = this;
      vm.$router.push({ path: url.routerUrl_C0001, query: returnC0001Param })
    },
    //印刷処理
    print_click() {
      this.set_loading()
      amsApi.PDFFile_get(this.contractPath).then(res_file => {
        let fileUrl = {}
        let blob = new Blob([res_file], { type: 'application/octet-stream;charset=UTF-8' })
        let url = window.URL.createObjectURL(blob)
        fileUrl.url = url
        fileUrl.name = this.contractPath
        for (let index = 0; index < 2; index++) {
          fileUrl.name = fileUrl.name.substring(fileUrl.name.indexOf('/') + 1)
        }
        this.download(fileUrl)
        this.close_loading()
      }).catch((err) => {
        //关闭loading
        this.close_loading()
      });
    },
    //pdfダウンロード
    download(file) {
      this.pdfUrl = file
      this.viewVisible = true
    },
    pdfClose() {
      this.viewVisible = false;
    },
    //表格行样式
    c0002IsRowClass({ row, rowIndex }) {
      return 'c0002IsRowClass';
    },
    //表格单元格样式
    c0002IsCellClass({ row, rowIndex }) {
      return 'c0002IsCellClass'
    },
    //表格第一列与第二列样式
    c0002IsCellStyle({ row, colum, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return 'text-align:right;background:#d2eef8;'
      } else {
        return 'background:#fafafa;'
      }
    },
    pledgeCheckChange(isChack) {
      //誓約チェックがチェックOFFの場合、同意チェックもチェックOFFになる。
      if (isChack == false) {
        this.consentCheck = false;
      }
    },
  }
}
</script>
<style scope>
/* 表格行样式 */
.c0002IsRowClass {
  padding: 0px;
}

.c0002IsCellClass {
  border: 1px;
  border-style: solid;
  border-color: #ccc;
  padding: 0px;
}
.c0002IsCellClass .cell {
  padding: 0px 8px;
}
</style>


// WEBPACK FOOTER //
// src/module/page/c_0002.vue